export default __webpack_public_path__ + "static/large-datasets-1f5b1b584e059fd72dd9167497b4e737.png";